import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import React, { FC } from "react";
import { css } from "styled-components";

export interface CheckoutSectionHeaderStyles {
    headingGridItem?: GridItemProps;
    headingText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
}

export const checkoutSectionHeaderStyles: CheckoutSectionHeaderStyles = {
    headingGridItem: {
        width: 12,
        css: css`
            background-color: ${COLORS.checkout.sectionHeaderBg};
            padding: 10px 20px;
            border-radius: 8px;
            margin-bottom: 12px !important;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
        `,
    },
    headingText: {
        variant: "h4",
        css: css`
            margin-bottom: 0;
            color: ${COLORS.checkout.text.primary};
            font-family: ${TYPOGRAPHY.h4.fontFamily};
            font-size: ${TYPOGRAPHY.h4.size}px;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: ${TYPOGRAPHY.h4.lineHeight};
            font-style: ${TYPOGRAPHY.h4.fontStyle};
        `,
    },
    link: {
        css: css`
            font-size: 14px;
            font-weight: ${TYPOGRAPHY.weight.base};
        `,
    },
};

interface CheckoutSectionHeaderProps {
    title: string;
    styles?: CheckoutSectionHeaderStyles;
    linkText?: string;
    onLinkClick?: () => void;
    linkHref?: string;
}

const CheckoutSectionHeader: FC<CheckoutSectionHeaderProps> = ({ 
    title, 
    styles = checkoutSectionHeaderStyles, 
    linkText, 
    onLinkClick,
    linkHref 
}) => {
    return (
        <GridItem {...styles.headingGridItem}>
            <Typography {...styles.headingText} as="h3">
                {title}
            </Typography>
            {linkText && (
                <Link 
                    {...styles.link} 
                    type={linkHref ? undefined : "button"}
                    href={linkHref}
                    onClick={onLinkClick}
                >
                    {linkText}
                </Link>
            )}
        </GridItem>
    );
};

export default CheckoutSectionHeader;
